<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div
          v-if="accessDenied"
          class="alert alert-warning p-1"
        >
          Você não tem permissão para visualizar as batidas excluídas.
        </div>
        <div
          v-else-if="loadError"
          class="alert alert-danger p-1"
        >
          Não foi possível carregar as batidas excluídas. Tente novamente.
        </div>
        <base-crud
          ref="baseCrud"
          crud-name="Batidas Excluídas"
          :table="trashedChecksTable"
          :columns="columns"
          :options="options"
          :custom-filters="customFilters"
          :end-point="endPoint"
          :extra="extra"
          :enable-add="false"
          :enable-edit="false"
          :enable-delete="false"
          :enable-view="false"
          :data-form="dataForm"
          @setDateFilter="setDateFilter"
          @restore="restore"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function format(datetime) {
  // Horário local (America/Sao_Paulo), igual ao resto do sistema.
  return datetime ? moment(datetime).format('DD/MM/YYYY HH:mm:ss') : 'N/A'
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      trashedChecksTable: 'trashedChecksTable',
      accessDenied: false,
      loadError: false,
      dateFilter: '',
      customFilters: [
        {
          name: 'created_at',
          call: 'setDateFilter',
          type: 'calendar',
        },
      ],
      extra: [
        {
          id: 'restore',
          name: 'restore',
          title: 'Restaurar',
          label: ' Restaurar',
          class: 'btn btn-success',
          icon: 'fas fa-undo',
        },
      ],
      columns: [
        'id',
        'user_id',
        'created_at',
        'deleted_at',
        'deleted_by',
        'justification',
        'manual',
        'remote',
        'actions',
      ],
      tableData: [
        'id',
        'user_id',
        'created_at',
        'deleted_at',
        'manual',
        'remote',
      ],
      options: {
        filterByColumn: true,
        filterable: ['user_id'],
        sortable: ['created_at', 'deleted_at'],
        orderBy: { column: 'deleted_at', ascending: false },
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 25,
        perPageValues: [10, 25, 50, 100],
        texts: {
          filterPlaceholder: 'Pesquisar',
        },
        headings: {
          id: 'ID',
          user_id: 'Funcionário',
          created_at: 'Data/hora da batida',
          deleted_at: 'Excluída em',
          deleted_by: 'Excluído por',
          justification: 'Motivo da exclusão',
          manual: 'Manual',
          remote: 'Remota',
          actions: 'Ação',
        },
        requestFunction(data) {
          const requestData = {}
          const queryString = this.$parent.$parent.$parent.query(data.query)

          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['user']

          const view = this.$parent.$parent.$parent

          return axios
            .get(`${this.url}?${queryString}`, requestData)
            .then(response => {
              view.accessDenied = false
              view.loadError = false
              return response
            })
            .catch(error => {
              const status = error.response ? error.response.status : null

              if (status === 403) {
                view.accessDenied = true
              } else {
                view.loadError = true
              }

              this.dispatch('error', error)

              return {
                data: { data: [], count: 0, total: 0 },
              }
            })
        },
        templates: {
          user_id(createElement, rowData) {
            if (rowData && rowData.user && rowData.user.name) {
              return rowData.user.name
            }
            return rowData && rowData.user_id ? `ID ${rowData.user_id}` : 'N/A'
          },
          created_at(createElement, rowData) {
            return rowData && rowData.created_at_f
              ? rowData.created_at_f
              : format(rowData.created_at)
          },
          deleted_at(createElement, rowData) {
            return format(rowData.deleted_at)
          },
          deleted_by(createElement, rowData) {
            return rowData && rowData.deletion && rowData.deletion.deleted_by_name
              ? rowData.deletion.deleted_by_name
              : '—'
          },
          justification(createElement, rowData) {
            return rowData && rowData.deletion && rowData.deletion.justification
              ? rowData.deletion.justification
              : '—'
          },
          manual(createElement, rowData) {
            return rowData && rowData.manual ? 'Sim' : 'Não'
          },
          remote(createElement, rowData) {
            return rowData && rowData.remote ? 'Sim' : 'Não'
          },
        },
      },
      endPoint: 'checks/trashed/',
      dataForm: {},
    }
  },
  methods: {
    setDateFilter(value) {
      this.dateFilter = value || ''
    },
    restore(payload) {
      const row = payload && payload.row ? payload.row : null
      if (!row) return
      const self = this

      swal({
        title: 'Restaurar batida?',
        text: 'A batida voltará a aparecer no ponto do funcionário.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, restaurar',
        cancelButtonText: 'Não',
      }).then(value => {
        if (!value) return

        axios
          .post(`${self.$store.getters.api}checks/${row.id}/restore`)
          .then(() => {
            swal('Sucesso', 'Batida restaurada com sucesso!', 'success')
            self.$refs.baseCrud.$refs.table.refresh()
          })
          .catch(() => {
            swal('Erro', 'Não foi possível restaurar a batida.', 'error')
          })
      })
    },
    query(queryFilters) {
      const columns = {
        user_id: 'user_id',
      }

      let filters = ''

      if (this.dateFilter) {
        const day = encodeURIComponent(this.dateFilter)
        filters += `created_at=${day},${day}&`
      }

      $.each(queryFilters, (index, value) => {
        if (columns[index] && value !== null && value !== undefined && value !== '') {
          filters += `${columns[index]}=${encodeURIComponent(value)}&`
        }
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
